export default __webpack_public_path__ + "static/media/massup_background_m1.92deb25e.jpg";